import { render } from "./OffersRoute.vue?vue&type=template&id=71eae738&scoped=true"
import script from "./OffersRoute.vue?vue&type=script&lang=js"
export * from "./OffersRoute.vue?vue&type=script&lang=js"

import "./OffersRoute.vue?vue&type=style&index=0&id=71eae738&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71eae738"]])

export default __exports__